<template>
  <div :class="['navbar', boxShadow]">
    <Logo class="navbar__logo"/>
    <div class="navbar__wrapper">
      <el-menu
        class="el-menu"
        mode="horizontal"
        background-color="transparent"
        :text-color="'var(--nxt-color-primary)'"
        :active-text-color="'var(--nxt-color-tertiary)'"
        justify="end">
        <li class="el-menu__list is-first">
          <el-button circle @click="isActived = !isActived" class="button-menu">
            <font-awesome-icon :icon="['fas', 'bars']"/>
          </el-button>
        </li>
        <li class="el-menu__list">
          <div class="el-menu__list__legend">
            {{ $t('layout.navbar.title') }}
          </div>
        </li>
        <li class="el-menu__list el-menu__list__right">
          <div class="el-menu__list el-menu__list__right__phone">
            <span class="el-menu__list el-menu__list__right__phone__text">
              {{ this.$t('base.phoneNumber') }}
            </span>
          </div>
          <el-select
            v-model="projectSelected"
            :disabled="projectSelectorDisabled"
            v-if="projects.length > 1"
            value-key="token"
            class="el-menu__list__right__select-project">
            <el-option
              v-for="project in projects"
              :key="project.token"
              :label="`${project.departure_city} - ${project.arrival_city}`"
              :value="project">
            </el-option>
          </el-select>
          <el-dropdown
            class="el-menu__list__right__dropdown"
            @command="dropdownClick"
            trigger="click">
            <span>
              <font-awesome-icon
                :icon="['fal', 'user-circle']"
                class="el-menu__list el-menu__list__right__user-button" />
              <span class="el-menu__list el-menu__list__right__user-text">{{ name }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="el-menu__list__right__dropdown">
              <el-dropdown-item v-if="!profileDisabled" command="profile">
                <font-awesome-icon
                  :icon="['fal', 'user']"
                  style="margin-right:10px"/>
                  <span>{{ $t('layout.navbar.account') }}</span>
              </el-dropdown-item>
              <el-dropdown-item command="signOut">
                <font-awesome-icon
                  :icon="['fal', 'sign-out-alt']"
                  style="margin-right:10px"/>
                  <span>{{ $t('layout.navbar.signOut') }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <div v-if="isActived" class="el-menu__bg" @click="isActived = !isActived"></div>
        <burger-menu :is-actived="isActived"/>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import cookie from '@nextories/vue-core-components/src/utils/helpers/cookie';
import BurgerMenu from '@/components/layout/BurgerMenu.vue';
import Logo from '@/components/layout/Logo.vue';
import breakpoints from '@/assets/scss/breakpoints-export.scss';
import WrapperNavbar from '../../utils/components/WrapperNavbar.vue';

export default {
  name: 'navbar',
  extends: WrapperNavbar,
  components: {
    BurgerMenu,
    Logo,
  },
  data() {
    return {
      project: '',
      isActived: false,
    };
  },
  computed: {
    ...mapGetters({
      demand: 'demandStore/demand',
      projects: 'projectStore/projects',
      projectSelectedStore: 'projectStore/projectSelected',
    }),
    projectSelected: {
      get() {
        return this.projectSelectedStore;
      },
      set(projectSelected) {
        this.setProjectSelected(projectSelected);
      },
    },
    name() {
      if (!this.demand || !this.demand.first_name) {
        return '';
      }
      if (this.demand.first_name.length < 12) {
        return this.demand.first_name;
      }
      return this.$t('layout.navbar.profile');
    },
    profileDisabled() {
      return this.projectSelected.params.disable_password;
    },
    projectSelectorDisabled() {
      const disabledRoutes = [
        'choice',
        'services',
      ];
      return disabledRoutes.includes(this.$route.name);
    },
  },
  methods: {
    ...mapActions({
      logout: 'authStore/logout',
      setProjectSelected: 'projectStore/setProjectSelected',
    }),
    dropdownClick(commands) {
      this[commands]();
    },
    signOut() {
      cookie.deleteCookie(process.env.VUE_APP_COOKIE_TOKEN_NAME);
      this.logout();
      this.$router.push({ name: 'login' });
    },
    profile() {
      this.$router.push({ name: 'profile' }).catch((err) => err);
    },
    resize() {
      if (this.isActived && breakpoints.desktop < window.innerWidth) {
        this.isActived = !this.isActived;
      }
    },
  },
  watch: {
    '$route.name': {
      handler() {
        this.isActived = false;
      },
    },
    projectSelected() {
      this.isActived = false;
    },
  },
};
</script>

<style lang="scss" scoped>

.navbar {
  border-bottom: solid 1px $--color-light-grey!important;
  position: fixed;
  display: flex;
  z-index: 50;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  color: $--color-white;
  &__logo {
    display: none;
    @include breakpoint(desktop) {
      display: block;
    }
  }
  &__wrapper {
    flex: 1 1 0%;
  }
  .el-menu {
    height: 60px;
    border: none!important;
    .button-menu {
      margin-top: 10px;
      margin-left: 10px;
      @include breakpoint(desktop) {
        display: none;
      }
    }
    &__list {
      display: inline;
      &__legend {
        display: none;
        margin-top: 18px;
        margin-left: 20px;
        @include breakpoint(wide) {
          display: inline-block;
        }
      }
      &__right {
        float: right;
        margin-top: 12px;
        margin-right: 20px;
        outline: none;
        &__phone {
          display: none;
          margin-right: 40px;
          @include breakpoint(tablet) {
            display: inline-block;
          }
          &__text {
            border-radius: 3px;
            padding: 5px 10px;
            border: $--color-white 1px solid;
          }
        }
        &__dropdown {
          cursor: pointer;
          color: $--color-white;
        }
        &__select-project {
          display: none;
          margin-right: 20px;
          @include breakpoint(mobile) {
            display: inline-block;
          }
        }
        &__user-button {
          outline: none;
          vertical-align: top;
          margin-right: 10px;
          width: 2.5em;
          height: 2.5em;
        }
        &__user-text {
          outline: none;
          user-select: none;
          line-height: 35px;
          height: 35px;
          font-size: 20px;
        }
      }
    }
    &__bg {
      background-color: $--color-black;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0.6;
      z-index: 1000;
      position: fixed;
    }
  }
  &--box-shadow {
    color: $--color-primary;
    background-color: $--color-light-grey;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    .el-menu__list__right__phone__text {
      border: $--color-primary 1px solid;
    }
    .el-menu__list__right__dropdown {
      color: $--color-primary;
    }
  }
}

</style>
